export const NotificationFields = [
    { key: "actions", label: "Actions" },
    { key: "message", label: "Message" },
    { key: "createdAt", label: "Created At", type: "datetime" },

]